export default {"src":"/_next/static/media/flexible-support-mobile.75ebe392.svg","height":48,"width":40};